














import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import rtStep from "@/components/couponcancel/rtStep.vue";

const retreatCouponModule = namespace("retreatCoupon");

@Component({
  components: {
    rtStep
  }
})
export default class CouponVerification extends Vue {
  @retreatCouponModule.State("selectStep") active!: number;
}
